import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Junta classes condicionais e resolve conflito de utilitario do Tailwind
 * (o ultimo vence). Padrao do shadcn/ui, base de todo componente.
 */
export function cn(...entradas: ClassValue[]): string {
  return twMerge(clsx(entradas));
}

/**
 * Minusculo e sem acento, pra comparar texto digitado contra rotulo em
 * portugues sem exigir que a pessoa digite o acento certo (ex.: "veic" tem
 * que achar "Veículos"). `NFD` separa a letra do sinal diacrítico do sinal em
 * si, e `\p{Diacritic}` (propriedade Unicode, precisa da flag `u`) remove só
 * o sinal, mantendo a letra.
 */
export function normalizarBusca(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
